import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'ranking-bar',
  imports: [CommonModule],
  templateUrl: './ranking-bar.component.html',
  styleUrl: './ranking-bar.component.scss'
})
export class RankingBarComponent implements AfterViewInit, OnChanges {
  @Input() ranking: number = 0;
  @Input() customer!:any;
  @Input() readonlyRankingBar?: boolean = false;
  @Input() arrowCalibrationPx?: number;
  @Output() rankingChange = new EventEmitter<number>();

  @ViewChild('trackRoot') trackRoot?: ElementRef<HTMLElement>;
  
  numbers: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  arrowLeftPx = 0;
  private resizeObserver?: ResizeObserver;

  get effectiveRanking(): number {
    return this.ranking && this.ranking > 0 ? this.ranking : 8;
  }
  
  constructor(private ngZone: NgZone, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.scheduleArrowRecalculation();
    const track = this.trackRoot?.nativeElement;

    if (track && typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.scheduleArrowRecalculation();
      });
      this.resizeObserver.observe(track);
    }
  }

  ngOnChanges(): void {
    this.scheduleArrowRecalculation();
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  onRankingInput(event: any): void {
    const newValue = parseInt(event.target.value, 10);
    
    if (newValue >= 0 && newValue <= 15) {
      this.ranking = newValue;
      this.rankingChange.emit(this.ranking);
      this.scheduleArrowRecalculation();
    } else {
      event.target.value = this.ranking;
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.scheduleArrowRecalculation();
  }

  private scheduleArrowRecalculation(): void {
    this.ngZone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        this.recalculateArrowPosition();
        this.cdr.detectChanges();
      });
      setTimeout(() => {
        this.recalculateArrowPosition();
        this.cdr.detectChanges();
      }, 80);
    });
  }

  private recalculateArrowPosition(): void {
    const track = this.trackRoot?.nativeElement;

    if (!track) {
      return;
    }

    const trackWidth = track.getBoundingClientRect().width;
    const rankingPosition = (Math.max(1, Math.min(15, this.effectiveRanking)) - 0.5) / this.numbers.length;
    const calibratedCenter = trackWidth * rankingPosition + this.getArrowCalibrationPx();
    const markerHalfWidth = 6;
    this.arrowLeftPx = Math.max(markerHalfWidth, Math.min(trackWidth - markerHalfWidth, calibratedCenter));
  }

  private getArrowCalibrationPx(): number {
    if (typeof this.arrowCalibrationPx === 'number') {
      return this.arrowCalibrationPx;
    }

    if (typeof window !== 'undefined' && window.devicePixelRatio <= 1) {
      return 0.5;
    }

    return 0;
  }
}
